export default "<ion-app>\n  <ion-router-outlet id=\"content\" #masterNav></ion-router-outlet>\n</ion-app>\n";